"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverTripAffectationStatisticsOutput = exports.DispatchRateOutput = exports.AcceptationRateOutput = void 0;
const class_validator_1 = require("class-validator");
/**
 * Describe an acceptation rate. rate = tripAcceptedCount / tripSubmittedCount
 */
class AcceptationRateOutput {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Object)
], AcceptationRateOutput.prototype, "rate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AcceptationRateOutput.prototype, "tripAcceptedCount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], AcceptationRateOutput.prototype, "tripSubmittedCount", void 0);
exports.AcceptationRateOutput = AcceptationRateOutput;
/**
 * Describe a dispatch rate. rate = tripDispatched / tripAccepted
 */
class DispatchRateOutput {
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Object)
], DispatchRateOutput.prototype, "rate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], DispatchRateOutput.prototype, "tripAcceptedCount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    __metadata("design:type", Number)
], DispatchRateOutput.prototype, "tripDispatchedCount", void 0);
exports.DispatchRateOutput = DispatchRateOutput;
/**
 * Output containing trip acceptation rate statistics for a driver
 */
class DriverTripAffectationStatisticsOutput {
}
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", AcceptationRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "globalAcceptationRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", AcceptationRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "futureTripAcceptationRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", AcceptationRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "flashTripAcceptationRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DispatchRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "globalDispatchRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DispatchRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "futureDispatchRate", void 0);
__decorate([
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DispatchRateOutput)
], DriverTripAffectationStatisticsOutput.prototype, "flashDispatchRate", void 0);
exports.DriverTripAffectationStatisticsOutput = DriverTripAffectationStatisticsOutput;
